import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { NftMoleculeReatom } from "./nft-store.reatom"

export const useNftReatom = () => {
  const { nftQueryParamsAtom } = useMolecule(NftMoleculeReatom)

  // Get query params from atom and use with TanStack Query
  const queryParams = nftQueryParamsAtom()

  const {
    data: { nft },
  } = useSuspenseQuery(queryParams)

  return nft
}
